import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Tracks a "data version" that bumps on every mutation. Components that
 * subscribe via useDataVersion() will re-fetch when the version changes.
 */
const DataVersionContext = createContext({ version: 0, bump: () => {} });

export function DataVersionProvider({ children }) {
  const [version, setVersion] = useState(0);
  const bump = useCallback(() => setVersion((v) => v + 1), []);
  return (
    <DataVersionContext.Provider value={{ version, bump }}>
      {children}
    </DataVersionContext.Provider>
  );
}

export const useDataVersion = () => useContext(DataVersionContext);
